import { supabase } from "@/lib/supabase";
import type { Tables } from "@synkro/db";

export type Notification = Tables<"notifications">;

/**
 * Las ultimas del buzon. No hay paginacion a proposito: una campana con
 * scroll infinito es un archivo, no un aviso. Lo que pasa de aqui se consulta
 * en la pantalla del pedido.
 */
export async function fetchNotifications(
  organizationId: string,
  limit = 20,
): Promise<Notification[]> {
  const { data, error } = await supabase
    .from("notifications")
    .select("*")
    .eq("organization_id", organizationId)
    .order("created_at", { ascending: false })
    .limit(limit);

  if (error) throw error;
  return data ?? [];
}

export async function markRead(ids: string[]): Promise<void> {
  if (ids.length === 0) return;

  const { error } = await supabase
    .from("notifications")
    .update({ read_at: new Date().toISOString() })
    .in("id", ids)
    .is("read_at", null);

  if (error) throw error;
}

/**
 * Avisa cuando entra una notificacion nueva sin recargar la pagina.
 *
 * Es la diferencia entre una campana y un contador: quien atiende la tienda
 * tiene el panel abierto en una pestaña y necesita enterarse del pedido
 * mientras hace otra cosa.
 */
export function subscribeToNotifications(
  organizationId: string,
  onNew: (notification: Notification) => void,
): () => void {
  const canal = supabase
    .channel(`notifications:${organizationId}`)
    .on(
      "postgres_changes",
      {
        event: "INSERT",
        schema: "public",
        table: "notifications",
        filter: `organization_id=eq.${organizationId}`,
      },
      (payload) => onNew(payload.new as Notification),
    )
    .subscribe();

  return () => {
    void supabase.removeChannel(canal);
  };
}
